// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"d5ed7f4a4ab094bf95ac","339":"8c42f5f6df46db0faa29"}[chunkId] + ".js";
};